export function deliveryRecipient({type, company, companyName, name, fullName}) {
  const text = value => (value || '').trim();
  const business = type === 'company';
  const recipient = business ? text(companyName) || text(company) : text(name) || text(fullName);
  const person = text(fullName) || (text(name) !== recipient ? text(name) : '');
  return {name: recipient, reference: business && person !== recipient ? person : ''};
}
